const {bind} = require('./bind')
const xmlParser = require('./xml-parser')

class Request {
  constructor(url, {
    method = 'GET',
    success = function() {},
    progress = function() {},
    error = function() {},
    data = null,
    type = 'json',
    successStatus = 200
  }) {
    const request = new XMLHttpRequest()

    if (type == 'xml') {
      request.responseType = 'text'
    } else {
      request.responseType = type
    }

    bind(request, 'readystatechange', function() {
      if (request.readyState == 4) {
        if (request.status == successStatus) {
          let response = null
          switch (type) {
            case 'json':
              response = request.response
              break
            case 'xml':
              response = xmlParser(request.responseText)
              break
            default:
              response = request.responseText
          }
          success(response)
        } else {
          error(request)
        }
      }
    })

    bind(request.upload, 'progress', progress)

    request.open(method, url, true);
    request.send(data);

    return request
  }
}

class Get {
  constructor(url, options = {}) {
    options.method = 'GET'
    return new Request(url, options)
  }
}

class Post {
  constructor(url, options = {}) {
    options.method = 'POST'
    return new Request(url, options)
  }
}

module.exports = {Request, Get, Post}
